module.exports = __webpack_public_path__ + "img/comment-dots.67773a41.svg";